import { Injectable } from '@angular/core';
import { Session } from '@models/Sessions/Session';

import { RequestService } from '../request.service';

@Injectable()
export class IdeaFromDocService {
  api = {
    root: '/session',
    idea: '/ideas',
    fromDoc: '/from-doc',
  };

  constructor(private client: RequestService) {}

  createIdeaFromDoc(session: Session, doc: File) {
    const formData: FormData = new FormData();
    formData.append('doc', doc, doc.name);

    return this.client.upload<any, any>(formData, {
      uri: this.api.root + `/${session._id}` + this.api.idea + this.api.fromDoc,
      body: {},
      handlers: {
        success: () => void 0,
        error: () => void 0,
      },
    });
  }
}
